import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import InfoWithExpandableCardsComponent from './InfoWithExpandableCardsComponent'

export interface IAttributes {
  iconUrl: string
  title: string
  description: React.ReactNode
  background: 'blue' | 'white'
  reverse: boolean
  showAccordionIcons: boolean
  ctaText: string
  ctaLink: string
  ctaClassName?: string
  card1IconUrl: string
  card1Title: string
  card1Description: string
  card2IconUrl: string
  card2Title: string
  card2Description: string
  card3IconUrl: string
  card3Title: string
  card3Description: string
  presentation?: 'image' | 'tagline'
  tagline?: string
  sublabel?: string
}

const InfoWithExpandableCardsSectionBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return <InfoWithExpandableCardsComponent {...attributes} />
}

export default InfoWithExpandableCardsSectionBlock
